var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import OpportunitySourceService from "../../../../Services/OpportunitySource.service";
import ContentLayout from "../../../Layout/ContentLayout";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import DateService from "../../../../Services/Shared/Date.service";
import { getOpportunitySourceCreateRoute, getOpportunitySourceDetailPath, } from "./OpportunitySourceRoutes";
import SecondaryNavButton from "../../../UI/SecondaryNav/SecondaryNavButton";
import SecondaryNavLayout from "../../../Layout/SecondaryNavLayout";
import PageTitle from "../../../UI/PageTitle/PageTitle";
import { InlineFormFormat } from "../../../UI/FormFormat/FormFormat";
import TextField from "../../../Form/TextField";
import SearchField from "../../../Form/SearchField";
import { OpportunitySourceCategoryMultiSearch } from "../../../Presentational/OpportunitySourceCategory/OpportunitySourceCategorySearch";
import NumberService from "../../../../Services/Shared/Number.service";
const PAGE_SIZE = 50;
const OpportunitySourceListTable = () => {
    var _a, _b;
    const [searchArgs, setSearchArgs] = React.useState({});
    const { table, dataState } = usePagedSortedTable({
        striped: true,
        hover: true,
        noDataComponent: "No opportunity sources found",
        rowVerticalPadding: 2,
        searchArgs,
        getData: (sort, pageNumber, sArgs) => {
            return OpportunitySourceService.search({
                query: sArgs.query,
                opportunitySourceCategoryIds: sArgs.opportunitySourceCategoryIds,
            }, {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
            });
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "Name",
                sortId: "OPPORTUNITY_SOURCE_NAME",
            },
            {
                title: "Category",
                sortId: "OPPORTUNITY_SOURCE_OPPORTUNITY_SOURCE_CATEGORY",
            },
            {
                title: "Modified By",
                sortId: "OPPORTUNITY_SOURCE_MODIFIED_BY",
            },
            {
                title: "Modified Date",
                sortId: "OPPORTUNITY_SOURCE_MODIFIED_DATE",
            },
        ],
        rows: ({ data }) => data.map((opportunitySource, index) => {
            return [
                _jsx(Link, { to: getOpportunitySourceDetailPath(opportunitySource.id), children: opportunitySource.name }, index),
                opportunitySource.opportunitySourceCategory.name,
                opportunitySource.modifiedBy.fullName,
                DateService.displayLongWithTimeWithoutWeekday(opportunitySource.modifiedDate),
            ];
        }),
    });
    return (_jsxs(_Fragment, { children: [_jsxs(PageTitle, { className: "mb-3", children: ["Opportunity Sources", " ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total)
                        ? `(${NumberService.format((_b = dataState.data) === null || _b === void 0 ? void 0 : _b.total)})`
                        : ""] }), _jsx("div", { className: "mb-3", children: _jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                        var _c;
                        setSearchArgs({
                            query: formState.query,
                            opportunitySourceCategoryIds: (_c = formState.opportunitySourceCategories) === null || _c === void 0 ? void 0 : _c.map((osc) => osc.id),
                        });
                    }), children: [_jsx(TextField, { name: "query", label: "Search name" }), _jsx(SearchField, { label: "Category", name: "opportunitySourceCategories", as: (provided) => (_jsx(OpportunitySourceCategoryMultiSearch, Object.assign({}, provided))) })] }) }), _jsx("div", { className: "py-2", children: table })] }));
};
const OpportunitySourceList = () => {
    return (_jsx(SecondaryNavLayout, { dontAddSpacer: true, nav: _jsx("div", { className: "d-flex", children: _jsx(Link, { to: getOpportunitySourceCreateRoute(), title: "New", tabIndex: -1, children: _jsx(SecondaryNavButton, { icon: "plus", label: "New", title: "New", iconType: "fas" }) }) }), children: _jsx(ContentLayout, { whiteBackground: true, paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(OpportunitySourceListTable, {}) }) }));
};
export default OpportunitySourceList;
